import { types } from "@gadgetinc/mobx-quick-tree";
import { contentHash } from "../../utils";
import { ShopifyBasePartnerAppConfig } from "./ShopifyBasePartnerAppConfig";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
export const ShopifyPartnerAppConfig = ShopifyBasePartnerAppConfig("ShopifyPartnerAppConfig")
  .props({
    appURL: types.string,
  })
  .views((self) => ({
    get contentHash() {
      return contentHash([self.apiKey, self.apiSecretKey, self.appURL, self.appId, self.appName]);
    },
  }))
  .actions((self) => ({
    setAppURL(value: string) {
      self.appURL = value;
    },
  }));
